import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/components/LandingPage'
import ChangePassword from '@/components/ChangePassword'
import RequestReset from '@/components/RequestReset'
import SelectInstance from '@/components/SelectInstance'
import NoSeatsAvailable from '@/components/NoSeatsAvailable'
import ActionSessions from '@/components/ActiveSessions'
import CreateDemoUser from '@/components/CreateDemoUser'
import EndSessionNotification from '@/components/EndSessionNotification'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/change',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/reset',
      name: 'ResetReset',
      component: RequestReset
    },

    {
      path: '/instances',
      name: 'SelectInstance',
      component: SelectInstance,
      meta: {
        auth: true
      }
    },
    {
      path: '/noseats',
      name: 'NoSeatsAvailable',
      component: NoSeatsAvailable,
      meta: {
        auth: true
      }

    },
    {
      path: '/activesessions',
      name: 'ActiveSessions',
      component: ActionSessions,
      meta: {
        auth: true
      }
    },
    {
      path: '/createdemouser',
      name: 'CreateDemoUser',
      component: CreateDemoUser
    },
    {
      path: '/endsessionnotify',
      name: 'EndSessionNotification',
      component: EndSessionNotification
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js